import { createContext } from 'react';
import { BucketsContent } from '../../../types';

export type BrowseDataContextData = {
    buckets: BucketsContent;
    fetchNextPage: Function;
    hasNextPage: boolean | undefined;
    removeEvent: (bucketKey: string, eventId: string) => void;
};

export const BrowseDataContext = createContext<BrowseDataContextData>(
    {} as any,
);
